import './App.css';
import PersonList from './components/randomizer';

function App() {
  return (
    <div className="app">
      <main className="app-main">
        <PersonList />
      </main>
    </div>
  );
}

export default App;
